<template>
  <div v-swiper:NewsSlider="settings">
    <div class="swiper-wrapper">
      <slot />
    </div>
    <div class="relative text-center lg:hidden top-0  news-pagination swiper-pagination"></div>
  </div>
</template>
<script>
export default {
  name: 'NewsSlider',
  data () {
    return {
      settings: {
        slidesPerView: 1,
        direction: "horizontal",
        loop: false,
        spaceBetween: 40,
        noSwiping: false,
        pagination: {
          clickable: true,
          el: '.news-pagination',
        },
        allowTouchMove: true,
        breakpoints: {
          650: {
            slidesPerView: 2,
            spaceBetween: 20,
            noSwiping: false,
            allowTouchMove: true,
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 20,
            noSwiping: true,
            allowTouchMove: false,
          }
        }
      }
    }
  }
}
</script>
